"use client";

import { getStarVariants, TrustpilotStar } from "@/components/custom/ProductBuilder/TrustpilotStar";
import { useTrustpilotRating } from "@/queries/useTrustpilotRating";

export function TrustpilotCartWidget() {
  const { data } = useTrustpilotRating();
  if (!data) return null;

  const starVariants = getStarVariants(data.rating, 5);

  return (
    <a
      href="https://www.trustpilot.com/review/stickergiant.com"
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-2 py-2 no-underline! hover:opacity-100!"
    >
      <div className="flex items-center gap-0.5">
        {starVariants.map((variant, index) => (
          <TrustpilotStar key={`cart-trust-star-${index}-${variant}`} variant={variant} />
        ))}
      </div>
      <span className="text-xs leading-none font-bold text-base-foreground">{data.ratingLabel}</span>
      {/* biome-ignore lint/performance/noImgElement: small static SVG logo, next/image adds no value */}
      <img src="/trustpilot-logo.svg" alt="Trustpilot" className="ml-auto h-5" />
    </a>
  );
}
